require('./jv.search.collection.service');

angular.module('jv.search.collection-list-modal.directive', [
    'jv.search.collection.service'
])
.controller('jvSearchCollectionListModalController', [
    '$scope', '$http', 'jvSearchCollectionService',
    function($scope, $http, jvSearchCollectionService) {
        $scope.state = {};
        $scope.state.showDeleteConfirm = false;

        function setState() {
            jvSearchCollectionService.list().then(function(data) {
                $scope.state.list = data.collections;
                $scope.state.selectedItem = null;
            }, showOperationError);
        }

        function showOperationError() {
            $scope.$emit('showMessageBar', {
                message: i18n['UNABLE_TO_PERFORM_OPERATION'],
                type: 'error'
            });
        }

        $scope.select = function() {
            $scope.onSelect({
                item: $scope.state.selectedItem
            });
            $scope.hide();
        };

        $scope.confirmDelete = function(item) {
            var process;
            process = jvSearchCollectionService.delete(item.EId);
            // selectLoading.enqueue(process);
            process.then(function() {
                $scope.state.deletedItem = item;
                $scope.state.showDeleteConfirm = true;
                $scope.state.selectedItem = null;
                var index = $scope.state.list.indexOf(item);
                if (index > -1) {
                	// remove the delete item from the list
                	$scope.state.list.splice(index, 1);
                }
            }, showOperationError);
        };
        
        $scope.delete = function(item) {
        	$scope.state.list.forEach(function(item) {
        		item.deleting = false;
        	});
            item.deleting = true;
            $scope.state.selectedItem = null;
        };
        
        $scope.cancelDelete = function(item) {
            item.deleting = false;
        };

        $scope.$watch('state.query', function() {
            $scope.state.selectedItem = null;
            $scope.state.showDeleteConfirm = false;
        });
        
        $scope.$watch('state.selectedItem', function() {
        	$scope.state.showDeleteConfirm = false;
        });

        $scope.$watch('show', function(val) {
            if (val) {
            	$scope.state.showDeleteConfirm = false;
                setState();
            }
        });
    }
])
.directive('jvSearchCollectionListModal', [
    function() {
        return {
            scope: {
                hide: '&',
                show: '=',
                onSelect: '&'
            },
            controller: 'jvSearchCollectionListModalController',
            templateUrl: jvUrls.jhire + '/modules/candidates/modals/collectionList.html'
        }
    }
]);